<template>
  <div class="invoice"></div>
</template>

<script>
import { getPersonalInvoiceApi } from '@/api/financial'

/**
 * @description 个人发票信息组件
 */
export default {
  name: 'PersonalInvoice',

  data() {
    return {
      invoiceInfo: {
        // 收票人手机号
        employeeMobile: '',
        // 收票人邮箱
        employeeEmail: ''
      }
    }
  },

  methods: {
    /**
     * 获取发票信息
     */
    setInvoiceData() {
      getPersonalInvoiceApi()
        .then(res => {
          this.invoiceInfo = res.data || {}
          this.$emit('getInvoiceInfo', this.invoiceInfo)
        })
        .catch(err => {
          console.error('获取个人发票信息失败：', err)
          if (err?.data?.message) this.$message.error(err.data.message)
        })
    }
  }
}
</script>

<style scoped lang="scss"></style>
